// extracted by mini-css-extract-plugin
module.exports = {"main":"TopBadges_main__LS3o2","secondary":"TopBadges_secondary__5zD9I"};